define('table_row_selection', function () {
    var trs = {
        bindChangeEvents: function(_elem, tableReference, callback) {
            $(_elem).on("click", function(evt) {
                evt.stopPropagation();

                if(tableReference && $(evt.currentTarget).prop("id") == "checkAll") // `Select/Deselect All` was clicked
                    $(tableReference).find("input:checkbox").not(this).prop('checked', this.checked);

                if(callback)
                    callback(this.checked);
            });
        },
        bindRowClick: function(_elem, callback) {
            $(_elem).on("click", function(evt) {
                $($(evt.currentTarget).find("input:checkbox")[0]).trigger("click");

                if(callback)
                    callback(this.checked);
            });
        }
    };

    return trs;
});